import { spineForJournal } from "@/src/components/common/broadsheet/tokens";
import ArticleList from "@/src/_types/Article/article-list";
import { getArticlePdfUrl, getArticleUrl } from "@/src/utils/paths";

export const MapToDocumentListItems = (data: {
  journal: Journal;
  documents: ArticleList[];
}): ArticleList[] => {
  return data.documents.map((document) => {
    return {
      id: document.id,
      title: document.title,
      display_order: document.display_order,
      pub_dates: document.pub_dates,
      feature_image_thumbnail: document.feature_image_thumbnail,
      feature_default_image: document.feature_default_image
        ? `${document.feature_default_image}`
        : null,
      issue_featured_image: document.issue_featured_image
        ? `${document.issue_featured_image}`
        : null,
      document_type: document.document_type || "",
      href: getArticleUrl(data.journal.meta_data?.title_abbr, document.id),
      flags: document.document_flags || null,
      authors: document.authors || [],
      pdf_file: getArticlePdfUrl(
        data.journal.meta_data?.title_abbr,
        document.id,
      ),
      proof_status: document.proof_status,
      desired_issue: document.desired_issue || null,
      desired_issue_id: document.desired_issue_id,
      issue_id: document.issue_id,
      doi: document.doi,
      has_altmetric: data.journal.services?.has_alt_metric?.status || false,
      spine: spineForJournal(data.journal),
      publon_badge: document.publon_badge || false,
    };
  });
};
